var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUphill2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 58,
    viewBox: "0 0 127 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.752 22.0984L121.384 31.908C120.734 34.6005 119.057 36.9317 116.71 38.4032L109.171 43.1314C99.3861 49.2676 87.0772 49.7397 76.8512 44.3711L74.9887 43.3932L70.2025 40.4304C62.9862 35.9631 54.4233 43.7257 58.1634 51.3443C59.0813 53.214 57.3996 55.3051 55.3765 54.8097L44.5843 52.1667C43.5501 51.9134 42.6021 51.3889 41.838 50.6473L35.6304 44.6223C30.3484 39.4957 21.5 43.2385 21.5 50.5993C21.5 51.9792 20.3071 53.0566 18.9343 52.9165L11.311 52.1386C6.59047 51.6569 3 47.6814 3 42.9364V26.0954C3 25.1913 3.07136 24.2886 3.2134 23.3958L3.90673 19.0377C5.04336 11.8932 11.8411 7.08699 18.9557 8.39758L20.1684 8.62098C20.9751 8.76957 21.746 9.07041 22.4401 9.50744L26.8639 12.2928C32.2636 15.6926 39.3856 12.52 40.4698 6.23197C40.7425 4.6501 42.2259 3.57352 43.8144 3.80457L63.0125 6.59703C64.9091 6.87289 66.8284 6.95927 68.7421 6.85489L84.4277 5.99931C89.8313 5.70457 95.1962 7.06634 99.8051 9.90259L108.303 15.1321C111.034 16.8125 114.364 17.2119 117.414 16.225C121.096 15.0338 124.66 18.3367 123.752 22.0984Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUphill2);
export default __webpack_public_path__ + "static/media/uphill2.36c35efe.svg";
export { ForwardRef as ReactComponent };